import type { WarehouseApi } from '../../warehouse/api/warehouse.api.js';
import { planDiff, type BuilderSnapshot, type DraftRack } from './builder.store.js';

/**
 * Qoralamani serverga yozadi.
 *
 * Tartib **muhim** va u shundan kelib chiqadi:
 *   1. Stellajlar zonadan oldin o'chiriladi — bo'sh bo'lmagan zonani server
 *      409 bilan rad etadi.
 *   2. Zonalar stellajlardan oldin yaratiladi — yangi stellajga zona `id` si
 *      kerak, u esa faqat yaratilgandan keyin paydo bo'ladi.
 *
 * So'rovlar ketma-ket ketadi, parallel emas: birinchi 409 da (`Katakda
 * mahsulot bor`) qolgan amallar bajarilmaydi va odam nima bo'lganini aniq
 * biladi. Reja saqlangandan keyin layout serverdan qaytadan o'qiladi —
 * mahalliy hisob-kitob bilan haqiqiy holat bir-biriga zid bo'lib qolmaydi.
 */

const rackBody = (rack: DraftRack, zoneId: string) => ({
  zoneId,
  code: rack.code,
  ...(rack.name === null || rack.name.length < 2 ? {} : { name: rack.name }),
  /* Tur faqat yaratishda ketadi: u o'zgarmaydigan xossa. */
  kind: rack.kind,
  pos: rack.pos,
  depthM: rack.depthM,
  bays: rack.bays,
  levelHeights: rack.levelHeights,
});

export const applyPlan = async (
  api: WarehouseApi,
  warehouseId: string,
  baseline: BuilderSnapshot,
  draft: BuilderSnapshot,
): Promise<void> => {
  const diff = planDiff(baseline, draft);

  for (const id of diff.racksToDelete) await api.deleteRack(id);
  for (const id of diff.zonesToDelete) await api.deleteZone(id);

  /** Mahalliy `local:*` identifikator → server identifikatori. */
  const zoneIds = new Map<string, string>();
  for (const zone of diff.zonesToCreate) {
    const created = await api.createZone({
      warehouseId,
      code: zone.code,
      name: zone.name,
      color: zone.color,
      plan: zone.plan,
    });
    zoneIds.set(zone.id, created.id);
  }

  for (const zone of diff.zonesToUpdate) {
    await api.updateZone(zone.id, { name: zone.name, color: zone.color, plan: zone.plan });
  }

  for (const rack of diff.racksToCreate) {
    await api.createRack(rackBody(rack, zoneIds.get(rack.zoneId) ?? rack.zoneId));
  }

  for (const rack of diff.racksToUpdate) {
    await api.updateRack(rack.id, {
      name: rack.name,
      pos: rack.pos,
      depthM: rack.depthM,
      bays: rack.bays,
      levelHeights: rack.levelHeights,
    });
  }
};
